module.exports = __webpack_public_path__ + "static/media/img3.b9564088.jpg";